import { Chip } from '@mui/material';
import { ITag } from 'services/api/entities';

interface TagsProps {
  tags?: ITag[];
}

const Tags = ({ tags }: TagsProps) => (
  <>
    {tags?.map((tag) => (
      <Chip key={tag.id} label={tag.name} variant="outlined" />
    ))}
  </>
);
export default Tags;
